import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { route } from "../../router/route";
import PretendardText from "../atoms/text/pretendardText";
import { useCookies } from "react-cookie";

const Header = (props) => {
  const navigate = useNavigate();

  // 마운트 시
  useEffect(() => {
    if (!sessionStorage.getItem("token")) {
      navigate(route.login, { replace: true });
    } else {
      const myInfo = JSON.parse(sessionStorage.getItem("wc_admin_myInfo"));
      setMyInfo(myInfo);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [myInfo, setMyInfo] = useState({});
  const [cookies, setCookie, removeCookie] = useCookies(["autoLogin"]);

  return (
    <HeaderWrapper>
      <HeaderInfo>
        <img src="/assets/admin/icons/ico_profile.svg" alt="프로필 사진" />
        <PretendardText
          style={{
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "32.5px",
            letterSpacing: "-0.3%",
            color: "#aaa",
          }}
        >
          {myInfo.email || ""}
        </PretendardText>
      </HeaderInfo>
      <LogoutBtn
        onClick={() => {
          navigate(route.login);
          sessionStorage.clear();
          removeCookie("autoLogin", { path: "/" });
        }}
      >
        로그아웃
      </LogoutBtn>
    </HeaderWrapper>
  );
};

export default Header;

const HeaderWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 73px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 15.8%;
  gap: 40px;
  position: absolute;
  z-index: 2;
  top: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
`;

const HeaderInfo = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const LogoutBtn = styled.button.attrs((props) => {})`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 88px;
  height: 41px;
  border-radius: 22px;
  background: #272829;
  color: #aaa;
  font-family: "Pretendard";
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 24.5px;

  &:hover {
    background: #313233;
  }
`;
